import firebase from "firebase"
import { history } from "../../../history"
import { config } from "../../../authServices/firebase/firebaseConfig"

// Init firebase if not already initialized
firebase.initializeApp(config)
let firebaseAuth = firebase.auth()

export const submitLoginWithFireBase = (email, password, remember) => {
  return dispatch => {
    firebaseAuth
      .signInWithEmailAndPassword(email, password)
      .then(result => {
        console.log('logged in...', result);
      })
      .catch(error => {
        console.log('err in login: ', error);
        alert(`${error.message}`)
      })
  }
}

export const logoutWithJWT = () => {
  return dispatch => {
    dispatch({ type: "LOGOUT_WITH_JWT", payload: {} })
    history.push("/login")
  }
}

export const logoutWithFirebase = user => {
  return dispatch => {
    dispatch({ type: "LOGOUT_WITH_FIREBASE", payload: {} })
    history.push("/login")
  }
}

export const changeRole = role => {
  return dispatch => dispatch({ type: "CHANGE_ROLE", userRole: role })
}

export const changeRoleFromClaims = role => {
  return dispatch => dispatch({ type: "CHANGE_ROLE_CLAIMS", roleFromClaims: role })
}

export const changeAuthLoading = authLoading => {
  return dispatch => dispatch({ type: "AUTH_LOADING", authLoading })
}

export const logout = () => {
  return dispatch => dispatch({ type: "LOG_OUT" });
}